module.exports = ".search-grid-image {\n  max-height: 60px;\n  vertical-align: middle;\n  text-align: center; }\n\n.search-grid-card {\n  margin-bottom: 10px;\n  margin-top: 10px; }\n\n.table thead th {\n  font-size: .8em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/spk/controls/spk-search-grid/spk-search-grid.component.scss
// module id = ./src/app/components/framework/spk/controls/spk-search-grid/spk-search-grid.component.scss
// module chunks = main